export {
  fetch,
  reset,
  add,
  save,
  remove
} from '@/common/store/helpers/mutations';

export const setLoading = (state, value = true) => (state.isLoading = value);
